export default __webpack_public_path__ + "static/media/trophy.ccb3d70d.svg";